import React from 'react'
import { getDescendantProp } from '../utility/funcs'
import { useTranslation } from '@fareye/common'

export function CustomErrorMessage(props: any) {
  const { t } = useTranslation()
  const { children, formKey } = props
  let message = ''
  if (formKey && typeof children != 'string') {
    message = getDescendantProp(children, formKey)
  } else if (typeof children == 'string') {
    message = children
  }
  return <>{`* ${t(message)}`}</>
}
